import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b02cbda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = { class: "modal-body" }

import { onMounted, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  closeLabel: {
    type: String,
    required: false,
    default: "Close",
  },
  closeGuard: {
    type: Function,
    required: false,
    default: undefined,
  },
},
  emits: ["modalClosing", "modalClosed"],
  setup(__props, { expose, emit }) {

const props = __props





const modalRef = ref<HTMLDialogElement | null>(null);

const modalShowing = ref(false);

const waitingForCloseGuard = ref(false);

function closeModal2(e: TransitionEvent) {
  if (e.target === modalRef.value) {
    modalRef.value?.removeEventListener("transitionend", closeModal2);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    modalRef.value?.close();
    emit("modalClosed");
  }
}

async function closeModal() {
  if (props.closeGuard) {
    if (waitingForCloseGuard.value) {
      return false;
    }

    waitingForCloseGuard.value = true;
    const proceed = await props.closeGuard();
    waitingForCloseGuard.value = false;

    if (!proceed) {
      return false;
    }
  }

  modalRef.value?.addEventListener("transitionend", closeModal2);
  modalShowing.value = false;
  emit("modalClosing");
}

function cancelHandler(e: Event) {
  e.preventDefault();
  closeModal();
}

function backdropClicked(e: MouseEvent) {
  if (e.target === modalRef.value) {
    closeModal();
  }
}

onMounted(() => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  modalRef.value?.showModal();

  // This setTimeout is needed for the transition to work in Safari
  setTimeout(() => {
    modalShowing.value = true;
  }, 0);
});

expose({ closeModal });

return (_ctx: any,_cache: any) => {
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("dialog", {
    ref_key: "modalRef",
    ref: modalRef,
    class: _normalizeClass(["modal", { 'modal-transition': modalShowing.value }]),
    onClick: backdropClicked,
    onCancel: cancelHandler
  }, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_BaseButton, {
          type: "button",
          "btn-style": "transparent",
          class: "modal-close",
          "aria-label": __props.closeLabel,
          icon: "xmark",
          onClick: closeModal
        }, null, 8, ["aria-label"]),
        _renderSlot(_ctx.$slots, "header")
      ]),
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ], 34))
}
}

})